import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { QuickViewDialogComponent } from './quick-view-dialog/quick-view-dialog.component';
import { Subscription } from 'rxjs';
import { AdvertService } from '@/services/common/advert.service';
import { Advert } from 'src/app/interfaces/common/';
import { truncateName } from '../../../helpers';

@Component({
  selector: 'app-marketplace-advert-card',
  templateUrl: './marketplace-card.component.html',
  styleUrls: ['./marketplace-card.component.scss'],
})
export class MarketplaceCardComponent implements OnDestroy {
  @Input() advert!: Advert;
  @Input() isOutputEventEmission?: boolean;
  @Output() clickCard = new EventEmitter<Advert>();

  private subAdvertById: Subscription = Subscription.EMPTY;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private advertService: AdvertService
  ) {}

  get name(): string {
    return this.advert?.name?.split(',').at(0) ?? '';
  }

  get advertImage(): string {
    const fallbackImg = '/assets/images/png/fallbackImage.png';
    if (!this.advert.images) return fallbackImg;
    return this.advert.images.at(0) ?? fallbackImg;
  }

  onClickToPrepopulate(event: Event, advert: Advert) {
    event.stopPropagation();

    if (this.isOutputEventEmission) {
      this.subAdvertById = this.advertService
        .getAdvertByShortId(advert.shortId)
        .subscribe(
          res => {
            if (res.success) this.clickCard.emit(res.data);
          },
          err => console.log(err)
        );
    } else this.router.navigate(['/ad-details', this.advert.shortId]);
  }

  public openComponentDialog(event: Event, id?: string) {
    event.stopPropagation();
    this.dialog.open(QuickViewDialogComponent, {
      data: id,
      panelClass: ['theme-dialog', 'full-screen-modal'],
      autoFocus: false,
      disableClose: false,
    });
  }

  // TODO: Consider transforming this to a pipe
  truncateAdvertName(name: string) {
    return truncateName(name);
  }

  onImageError({ target }: Event) {
    (target as HTMLImageElement).src = this.advertImage.replace(
      'preview',
      'watermarked'
    );
  }

  ngOnDestroy() {
    this.subAdvertById.unsubscribe();
  }
}
